export function isNode() {
  /**
   * Polyfills of 'process' might set process.browser === true
   *
   * See:
   * https://github.com/webpack/node-libs-browser/blob/master/mock/process.js#L8
   * https://github.com/defunctzombie/node-process/blob/master/browser.js#L156
  **/
  return typeof process !== 'undefined' && !process.browser;
}

export function getNodeVersion() {
  return process.versions.node ? 'v' + process.versions.node : process.version;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/contentful-sdk-core/dist/es-modules/utils.js
// module id = 71
// module chunks = 0 1 2 3 4 5 6 7